module.exports = __webpack_public_path__ + "static/img/recruit_2021_logo_pink.879f252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/recruit_2021_logo_pink.png
// module id = 563B
// module chunks = 0